import { PresentationViewPage } from "@pages/presentation/PresentationViewPage";
import { PresentationsListPage } from "@pages/PresentationsListPage";
import { AppRoute } from "./types";
import { ThemeProvider } from "@shared/providers/ThemeProvider";
import { sidekickModuleEnum } from "@shared/access-control/sidekick-modules";

export const presentationRoutes: AppRoute[] = [
  {
    path: "/presentations",
    element: <PresentationsListPage />,
    protected: true,
    requiredModule: sidekickModuleEnum.MLS_ACCESS,
  },
  {
    path: "/presentations/print",
    element: (
      <ThemeProvider defaultTheme={"light"}>
        <PresentationViewPage displayMode="print" />
      </ThemeProvider>
    ),
  },
  {
    path: "/presentations/:id/view",
    element: (
      <ThemeProvider defaultTheme={"light"}>
        <PresentationViewPage />
      </ThemeProvider>
    ),
  },
];
